/* import __COLOCATED_TEMPLATE__ from './mobile-unsupported-with-image.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

/**
 * `MobileUnsupportedWithImage` is designed to be a reusable component that can be included in:
 *   - The mobile unsupported page
 *   - A milestone in the setup guide blade if all the action items of the milestone are not supported on mobile web
 *   - The modal dialog that is opened after tapping on an action item that is not supported on mobile
 *
 * @example
 * <MobileUnsupportedWithImage @title="Title"
 *                             @subtitle="Subtitle"
 *                             @primaryCtaLabel="Open Square for Retail App"
 *                             @onPrimaryCtaTap={{this.primaryCtaAction}}
 *                             @secondaryCtaLabel="Switch to desktop site"
 *                             @onSecondaryCtaTap={{this.secondaryCtaAction}} />
 *
 * @param {string} title - The title's copy.
 * @param {string} subtitle - The subtitle's copy.
 * @param {string} primaryCtaLabel - The primary CTA's label.
 * @param {string} onPrimaryCtaTap - The function that will be called when the primary CTA is clicked/tapped on.
 * @param {string} secondaryCtaLabel - The secondary CTA's label
 * @param {string} onSecondaryCtaTap - The function that will be called when the secondary CTA is clicked/tapped on.
 * @param {string} [imageDirectory='/@dashboard/shared-ui/images/rtl'] - The directory the image is located in.
 * @param {string} [imageName='rtl-mobile-unsupported'] - The name of the image.
 * @param {string} [imageDescription='Retail mobile unsupported'] - Descriptive text for the image (`alt` text).
 * @param {string} [imageExtension='png'] - The extension to be used when generating the image path.
 */
let MobileUnsupportedWithImage = (_class = class MobileUnsupportedWithImage extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
  }
  get imageData() {
    return {
      directory: this.args.imageDirectory ?? '/@dashboard/shared-ui/images/rtl',
      description: this.args.imageDescription ?? 'Retail mobile unsupported',
      name: this.args.imageName ?? 'rtl-mobile-unsupported',
      extension: this.args.imageExtension ?? 'jpg'
    };
  }
  tapPrimaryAction() {
    this.args.onPrimaryCtaTap?.();
  }
  tapSecondaryAction() {
    this.args.onSecondaryCtaTap?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "tapPrimaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tapPrimaryAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tapSecondaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tapSecondaryAction"), _class.prototype), _class);
export { MobileUnsupportedWithImage as default };